export const PageDetails = {
  monarchMind: {
    id: 'monarchMind',
    title: 'MonarchMind',
    url: 'monarchMind',
    logo: '/img/monarchMind.svg',
    logoAlt: 'MonarchMind',
  },
  gemini: {
    id: 'gemini',
    page: 'gemini',
    title: 'Gemini',
    shortTitle: 'Gemini',
    icon: '/img/google-gemini-icon.svg.png',
    externalUrl: 'https://gemini.google.com/app',
    description: (
      <div>
        MonarchMind is being reimagined into a home-base app for multiple AI functionalities within
        the ODU online infrastructure. To access the old MonarchMind functionality of a secure,
        University-centered large language model, access Google Gemini through the link below.{' '}
        <b>When accessing Gemini, ensure you are logged into Google using your ODU credentials.</b>{' '}
        This will maintain a secure, Old Dominion University-focused interaction.
      </div>
    ),
    cardClass: 'gemini',
  },
  esga: {
    id: 'esga',
    page: 'esga',
    title: 'Editorial Style Guide Assistant',
    breadcrumbs: [{ title: 'Dashboard', href: '/' }],
    tooltip: (
      <div>
        The Editorial Style Guide Assistant (ESGA) allows users to upload documents to be analyzed
        against the specific rules of the official{' '}
        <a
          href="https://www.odu.edu/university-communications/brand-toolkit/styleguide"
          target="_blank"
        >
          ODU Style Guide
        </a>
        . The system uses AI to generate a report, highlighting non-adherence and offering
        corrections. Documents uploaded into this tool are not used to train other AI models, within
        the University or elsewhere.
        <br />
        <br />
        <b>
          AI can make mistakes. Such content is provided for informational purposes only and should
          not be relied upon for any specific purpose without verification of its accuracy or
          completeness.
        </b>
      </div>
    ),
    shortTitle: 'ESGA',
    icon: '/img/logos/esga.svg',
    description:
      'Upload documents to be analyzed against the specific rules of the official ODU Style Guide.  The system generates a report highlighting non-adherence and offering corrections.',
    cardClass: 'esga',
  },
  notebookLM: {
    id: 'notebookLM',
    page: 'notebookLM',
    title: 'NotebookLM',
    shortTitle: 'NotebookLM',
    icon: '/img/notebookLM.svg',
    externalUrl: 'https://notebooklm.google.com/',
    description: (
      <div>
        NotebookLM is an AI-powered research and note-taking application created by Google. It is
        designed to assist users in summarizing, analyzing, and synthesizing information from their
        documents. Built on Google Gemini models, it is a personalized, source-grounded tool that
        limits its responses to user-provided content.{' '}
        <b>
          To access a secure, University-centered NotebookLM experience, users should log into
          NotebookLM using ODU credentials.
        </b>
      </div>
    ),
    cardClass: 'notebookLM',
  },
};
